import clsx from 'clsx'
import React, {useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'
import useCalendarViewContext from '../../../../context/CalendarView'
import _ from 'lodash'
import {Select} from './Select'
import {data} from 'jquery'

export const DisplayFields = ({groupView, onChange = (ev, fields) => {}, display_fields}) => {
  const {entity_id} = groupView

  const {loadDisplayFields, displayFields} = useCalendarViewContext()
  const {t} = useTranslation()
  const [collapse, setCollapsed] = useState(false)

  const handleAddField = e => {
    if (display_fields?.length < 3) {
      onChange(e, [...display_fields, {name: null, field_id: null, key: null}])
    }
  }

  const handleChange = (ev, data) => {
    const {index, field, action_id, type} = data

    const n = {field_id: field.field_id, key: field.key, type: type}
    if (action_id) {
      n.action_id = action_id
    }

    display_fields[index] = n

    onChange(ev, [...display_fields])
  }

  function handleRemove(e, i) {
    display_fields.splice(i, 1)
    onChange(e, [...display_fields])
  }

  useEffect(() => {
    if (!_.isEmpty(groupView) && groupView?.entity_id !== -1) {
      const filtered = []
      const group_id = groupView.entity_id
      _.map(groupView.actions, function getData(val) {
        if (val.active) {
          filtered.push(val.action_id)
        }
      })
      loadDisplayFields(group_id, filtered)
    }
    // eslint-disable-next-line
  }, [groupView.entity_id, groupView?.actions])

  const options = useMemo(() => {
    if (!displayFields) return []
    let ret = []

    if (displayFields?.group_fields && displayFields?.group_fields.length) {
      ret.push({
        name: displayFields.data.group_name,
        items: displayFields?.group_fields.map(f => ({type: 'entity_field', field: f})),
      })
    }

    if (displayFields.action_fields && displayFields?.action_fields.length) {
      ret.push(
        ...displayFields?.action_fields.map(action_field => {
          return {
            name: action_field.action_name,
            items: action_field?.action_fields.map(field => ({
              type: field?.field_name === 'Action Name' ? 'action_name' : 'action_field',
              field: {...field, field_name: field.field_name},
              action_id: action_field.action_id,
            })),
          }
        })
      )
    }
    return ret
  }, [displayFields])

  return (
    <div className="ds-flex-col">
      <div>
        <div
          className={clsx('ds-flex-row ds-t080b ds-px-8', {
            'ds-disabled': entity_id === -1,
          })}
          style={{
            alignItems: 'center',
            justifyContent: 'space-between',
            height: 32,
          }}
        >
          <span className="ds-flex-no-spill">{t('calendar.view.add.display-fields.label')}</span>
          <button
            className="ds-circ-btn ds-circ-btn--fill"
            disabled={display_fields?.length >= 3}
            onClick={handleAddField}
          >
            <i className="ds-icon-add"></i>
          </button>
          <i
            className={clsx(
              'ds-ml-6 ds-icon-20x20',
              collapse ? 'ds-icon-caret-right' : 'ds-icon-caret-down'
            )}
            onClick={e => setCollapsed(p => !p)}
          ></i>
        </div>
        <div
          className={clsx('ds-pl-8 ds-t060r', {
            'ds-disabled': entity_id === -1,
          })}
        >
          {t('calendar.view.add.display-fields.description')}
        </div>
      </div>

      <hr className="ds-h-divider ds-mt-8 ds-mb-12" />

      <div className="ds-flex-col" style={{gap: 8}} hidden={collapse}>
        {!_.isEmpty(display_fields) &&
          display_fields.map((d, di) => (
            <div key={di} className="ds-flex-row" style={{gap: 12, alignItems: 'center'}}>
              <Select
                classes={{root: 'ds-flex-no-spill'}}
                value={d}
                items={options}
                placeholder={t('calendar.view.add.placeholder-select-field')}
                onChange={handleChange}
                render={(item, index, clickHandle) => (
                  <React.Fragment key={`r_${di}_${index}`}>
                    <div className="ds-menu-item ds-disabled">
                      <span className="ds-text-ellipsis">{item.name}</span>
                    </div>
                    {item.items.map((f, i) => (
                      <div
                        key={`r_${di}_${index}_${i}`}
                        onClick={e => clickHandle(e, {index: di, ...f}, i)}
                        className="ds-menu-item ds-pl-24"
                      >
                        <span className="ds-text-ellipsis">{f.field.field_name}</span>
                      </div>
                    ))}
                  </React.Fragment>
                )}
                selectedDisplay={(value, items) => {
                  let _i, _j, _f
                  for (_i = 0; _i < items.length; _i++) {
                    for (_j = 0; _j < items[_i].items.length; _j++) {
                      _f = items[_i].items[_j]
                      if (_f.type === value.type && _f.field.field_id === value.field_id) {
                        return _f.field.field_name
                      }
                    }
                  }
                }}
              />
              <i onClick={e => handleRemove(e, di)} className="ds-icon-remove ds-tr200"></i>
            </div>
          ))}
      </div>
    </div>
  )
}
